import { createSlice } from "@reduxjs/toolkit";

const companyDetailsSlice = createSlice({
  name: "companyDetails",
  initialState: {},
  reducers: {
    setCompanyDetails: (_state, action) => action.payload,
  },
});

export const { setCompanyDetails } = companyDetailsSlice.actions;

export const companyDetails = companyDetailsSlice.reducer;

export default companyDetailsSlice.reducer;
